export class FilterEditorService {
  constructor(
    $q,
    $timeout,
    $rootScope,
    FilterEditorModalService,
    FilterCardEditorModalService,
    FiltersCutEditorModalService,
    RulesEditorModalService,
    FiltersService,
    FilterResource,
    CurrentModelService,
    RouterService,
    CurrentFilterService,
    CurrentFilterDataService,
    AdminModalService,
  ) {
    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.FilterEditorModalService = FilterEditorModalService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.FiltersCutEditorModalService = FiltersCutEditorModalService;
    this.RulesEditorModalService = RulesEditorModalService;
    this.FiltersService = FiltersService;
    this.FilterResource = FilterResource;
    this.CurrentModelService = CurrentModelService;
    this.RouterService = RouterService;
    this.RouterService.FilterEditorService = this;
    this.modalInstance = null;
    this.isOpened = false;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.needReload = false;
    this.AdminModalService = AdminModalService;
  }

  editModal({
    filter,
    asNew,
    selectFilter,
    type,
    tabName,
  }) {
    if (this.isOpened) return;
    this.isOpened = true;
    if (!this.RouterService.modal) {
      this.RouterService.modal = 'filter-edit';
      this.RouterService.type = type;
    }
    return this.$q.resolve()
      .then(() => {
        if (this.RouterService.modal === 'cut-edit' && this.cut) {
          const openRes = this.FiltersCutEditorModalService.open(
            this.cut,
            this.FiltersService,
            asNew,
          );
          this.modalInstance = this.FiltersCutEditorModalService.modalInstance;
          return openRes;
        }
        if (this.RouterService.modal === 'rules-edit' && this.cut) {
          const rl = this.RulesEditorModalService;
          const openRes = this.RulesEditorModalService.open(
            this.cut,
            this.FiltersService,
            asNew,
          );
          this.modalInstance = this.RulesEditorModalService.modalInstance;
          return openRes;
        }
        if (this.RouterService.isFilterEditModal && this.RouterService.modal === 'filter-edit' &&
          this.cut && this.cut.dimension === 'analytics_filter@name:name') {
          filter = this.FiltersService.find(f => f.name === this.cut.value);
          if (!filter) return;
          selectFilter = false;
          this.needReload = true;
          // this.reloadUrl = this.RouterService
          const openRes = this.FilterEditorModalService.open(
            this.CurrentModelService.model,
            filter,
          );
          this.modalInstance = this.FilterEditorModalService.modalInstance;
          return openRes;
        }
        if (this.RouterService.isFilterEditModal) {
          const openRes = this.FilterEditorModalService.open(
            this.CurrentModelService.model,
            filter,
            asNew,
            tabName,
          );
          this.modalInstance = this.FilterEditorModalService.modalInstance;
          return openRes;
        }
      })
      .then(filterEdit => {
        if (this.RouterService.isFilterEditModal) {
          this.removeModal();
          if (filterEdit.deleted) {
            if (this.RouterService.isEditDasboard) return filterEdit;
            else {
              this.onDeleteFilter(filter);
              return filter;
            }
          }
          filterEdit.isChanged = false;

          if (this.RouterService.isEditDasboard && this.CurrentFilterService.filter.id !== filterEdit.id) {
            filterEdit.isChanged = true;
            this.RouterService.isEditDasboard = false;
            const targetFilter = this.CurrentFilterService.filter.isCardFilter ?
              this.CurrentFilterService.filter.cardFilter : this.CurrentFilterService.filter;
            if (!filterEdit.dIndex) {
              targetFilter.children.push(filterEdit);
              // this.$timeout(() => this.RouterService.$rootScope.$apply(), 10);
              this.RouterService.filter = targetFilter;
            }
            return filterEdit;
          }
          this.RouterService.isEditDasboard = false;

          if (asNew || !filter.id) {
            this.FiltersService.filters.push(filterEdit);
          } else {
            const originalFilter = this.FiltersService.findById(filterEdit.id);
            Object.keys(originalFilter).map(k => delete originalFilter[k]);
            Object.assign(originalFilter, filterEdit);
          }
          Object.keys(filter).map(k => delete filter[k]);
          Object.assign(filter, filterEdit);
          if (selectFilter) {
            this.RouterService.selectFilter(filterEdit.id, true);
          } else if (this.needReload) {
            window.CACHE.reset();
            this.$rootScope.$broadcast('reload');
          }

        } else {
          this.removeModal();
        }
        this.RouterService.isEditDasboard = false;
        if (filter.isPolitic && filter.applyType === 'all')
          this.AdminModalService.terminalCommand('reset_sessions', gettext('Перестроить отчеты'));
        return filterEdit;
      })
      .catch(error => {
        this.RouterService.isEditDasboard = false;
        this.removeModal();
      });
  }

  saveChildrenOrder(filter) {
    let chain = this.$q.when();
    for (let i = 0; filter.children && i < filter.children.length; i++) {
      if (!filter.children[i].deleted) {
        chain = chain.then((res) => {
          return this.FilterResource.changePosition(
            filter.children[i].id,
            i ? filter.children[i - 1].id : null,
            filter.id);
        });
      }
    }
    return chain;
  }

  saveChildren(filter) {
    let chain = this.$q.when();
    if (filter.children) {
      filter.children.filter(f => f.isChanged || f.deleted).forEach((child) => {
        chain = chain.then(() => {
          if (child.deleted) {
            return this.FiltersService.delete(child);
          }
          return this.FiltersService.save(child);
        });
      });
    }
    return chain;
  }

  saveFilter(asNew) {
    const filter = this.CurrentFilterService.filter;
    if ((asNew || !filter.id) && !filter.isDashboard) {
      this.editModal({
        filter,
        asNew,
        selectFilter: true
      });
      return;
    }

    if (filter.isDashboard) {
      this.FiltersService.save(filter)
        // .then(() => console.log('Сохранил дашборд:', filter.id, filter.name))
        .then(() => this.saveChildren(filter))
        // .then(() => console.log('сохранил всех детей:', filter.id, filter.name))
        .then(() => this.saveChildrenOrder(filter))
        // .then(() => console.log('запомнил порядок:', filter.id, filter.name))
        .then(() => this.RouterService.filterChanged());
    } else {
      this.FiltersService.save(filter).then(() => this.RouterService.filterChanged());
    }
  }

  onDeleteFilter(filter) {
    this.FiltersService.onDeleteFilter(filter);
    this.RouterService.onDeleteFilter();
    this.removeModal();
  }

  removeModal() {
    this.RouterService.removeModal();
    this.isOpened = false;
  }

  cancel() {
    if (this.isOpened && this.modalInstance) this.modalInstance.close();
    // delete this.RulesEditorModalService;
    this.RouterService.type = undefined;
  }

}



// WEBPACK FOOTER //
// ./src/filter/editor/filter-editor.service.js